export default __webpack_public_path__ + "static/silkserif-light-d2bac7891af4cd53cd171d9482a458e1.woff";